import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "assets-dashboard-card" }
const _hoisted_2 = { class: "assets-dashboard-card__header" }
const _hoisted_3 = { class: "assets-dashboard-title" }
const _hoisted_4 = { class: "assets-dashboard-title__text" }
const _hoisted_5 = { class: "assets-dashboard-card__body" }
const _hoisted_6 = {
  key: 0,
  class: "assets-dashboard-loading"
}
const _hoisted_7 = { class: "assets-dashboard-loading__text" }
const _hoisted_8 = {
  key: 1,
  class: "assets-dashboard-grid"
}
const _hoisted_9 = { class: "summary-tile summary-tile--total" }
const _hoisted_10 = { class: "summary-tile__content" }
const _hoisted_11 = { class: "summary-tile__value" }
const _hoisted_12 = { class: "summary-tile__label" }
const _hoisted_13 = { class: "summary-tile summary-tile--active" }
const _hoisted_14 = { class: "summary-tile__content" }
const _hoisted_15 = { class: "summary-tile__value" }
const _hoisted_16 = { class: "summary-tile__label" }
const _hoisted_17 = { class: "summary-tile__meta" }
const _hoisted_18 = { class: "summary-tile summary-tile--recent" }
const _hoisted_19 = { class: "summary-tile__content" }
const _hoisted_20 = { class: "summary-tile__value" }
const _hoisted_21 = { class: "summary-tile__label" }
const _hoisted_22 = { class: "summary-tile__meta" }
const _hoisted_23 = { class: "summary-tile summary-tile--inactive" }
const _hoisted_24 = { class: "summary-tile__content" }
const _hoisted_25 = { class: "summary-tile__value" }
const _hoisted_26 = { class: "summary-tile__label" }
const _hoisted_27 = { class: "summary-tile__meta" }
const _hoisted_28 = {
  key: 2,
  class: "assets-dashboard-error",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "assets-dashboard-title__icon" }, [
          _createElementVNode("i", { class: "bi bi-speedometer2" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('components.assetsDashboard.title')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[1] || (_cache[1] = _createElementVNode("div", {
              class: "spinner-border",
              role: "status",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('components.loading')), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "summary-tile__icon" }, [
                _createElementVNode("i", { class: "bi bi-hdd-stack-fill" })
              ], -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.stats.total), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('components.assetsDashboard.totalAssets')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "summary-tile__icon" }, [
                _createElementVNode("i", { class: "bi bi-check-circle-fill" })
              ], -1)),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.stats.active), 1),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('components.assetsDashboard.activeAssets')), 1),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('components.assetsDashboard.last30min')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "summary-tile__icon" }, [
                _createElementVNode("i", { class: "bi bi-clock-history" })
              ], -1)),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.stats.last24h), 1),
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('components.assetsDashboard.activeLast24h')), 1),
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('components.assetsDashboard.last24hours')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "summary-tile__icon" }, [
                _createElementVNode("i", { class: "bi bi-x-circle-fill" })
              ], -1)),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.stats.inactive), 1),
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('components.assetsDashboard.inactiveAssets')), 1),
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('components.assetsDashboard.moreThan30min')), 1)
              ])
            ])
          ])),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _cache[6] || (_cache[6] = _createElementVNode("i", {
              class: "bi bi-exclamation-triangle-fill",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetsDashboard.errorLoading')) + ": " + _toDisplayString(_ctx.error), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}